import { Hammer } from 'lucide-react';
import { EncabezadoPagina, ModuleLayout } from '@/components/layout/ModuleLayout';
import { Tarjeta, Vacio } from '@/components/ui/data';

/** Marcador para módulos aún no construidos en esta fase. */
export function Proximamente({ titulo }: { titulo: string }) {
  return (
    <ModuleLayout titulo={titulo}>
      <EncabezadoPagina titulo={titulo} />
      <Tarjeta>
        <Vacio icono={<Hammer />} titulo="En construcción" descripcion="Este módulo estará disponible muy pronto." />
      </Tarjeta>
    </ModuleLayout>
  );
}
